<div class="sub-header">
  <div class="sub-header-row px-1 py-2">
    <div class="row">
      <div class="col">
        <app-breadcrumb />
      </div>
    </div>

    <div class="row">
      <div class="col">
        @if (this.groups$ | async; as groups) {
          <div class="d-inline-block mx-2">
            <ng-select
              class="form-control form-control-sm"
              style="width: 235px;"
              bindValue="id"
              bindLabel="name"
              [items]="groups"
              [multiple]="true"
              [selectableGroup]="false"
              [closeOnSelect]="false"
              [clearable]="false"
              [(ngModel)]="this.groupIds"
              (ngModelChange)="this.onGroupIdsChange()"
            >
              <ng-template ng-multi-label-tmp let-items="items">
                @if (items.length === 1) {
                  {{ items[0].name }}
                }
                @if (items.length > 1) {
                  <span translate [translateParams]="{ p1: items.length }">ATTENDANCE_LBL_GROUP_SELECTED</span>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="group-{{ index }}" type="checkbox" [ngModel]="item$.selected" /><span class="ps-1" title="{{ item.name }}">{{ item.name }}</span>
              </ng-template>
            </ng-select>
          </div>
        }

        @if (this.users$ | async; as users) {
          <div class="d-inline-block mx-2">
            <ng-select
              class="form-control form-control-sm"
              style="width: 265px;"
              bindValue="id"
              bindLabel="name"
              [items]="users"
              [clearable]="false"
              [placeholder]="'ATTENDANCE_LBL_PICK_SALESPERSON' | translate"
              [ngModel]="this.userId"
              (ngModelChange)="this.onSalesPersonChange($event)"
            />
          </div>
        }
      </div>

      <div class="col-auto">
        @if (this.periods.length) {
          <div class="d-inline-block float-end mx-2">
            <select
              class="form-control form-control-sm form-select"
              style="width: 200px;"
              [ngModel]="this.period"
              (ngModelChange)="this.onPeriodChange($event)"
            >
              @for (group of this.periodGroups; track group) {
                <optgroup [label]="group">
                  @for (period of this.periods; track period.value) {
                    @if (period.group === group) {
                      <option [value]="period.value">{{ period.label }}</option>
                    }
                  }
                </optgroup>
              }
            </select>
          </div>
        }
      </div>
    </div>
  </div>
</div>
